import { UseTranslationResponse } from "react-i18next";
import { isUndefined, isString } from "lodash";

import { Order } from "../../../../../services";
import {
	getOrderPassengerPoints,
	stringifyPoint,
} from "../../../../../redux/constants/OrdersPage/order";
import { isTextMatchingAnySegmentFilterHelper } from "../../../../../utils";
import { OrderExecutingStage, OrderSource } from "../../../../../types";
import { CloseReason } from "../../../../../pages/MainPage/pages/Orders/components/CloseOrderModal/components/Content";
import { DateRange } from "../../../../../types/DataRange";
import type { ValueDefaultFilters } from "../constants/interface";
import {
	ORDER_STATUSES,
	ORDER_STATUSES_ENUM,
	PAYMENTS_ENUM,
	PAYMENTS,
} from "../constants";

enum TransferOptionEnum {
	SENT_TRANSFER = "sentTransfer",
	RECEIVED_TRANSFER = "receivedTransfer",
}

const tableRowClassName2 = (item?: Order.Model) => {
	if (isUndefined(item)) return "";

	const orderColor = item.additionalFields.displaySettings?.color;

	const classNameNodes: string[] = [];

	if (isString(orderColor) && orderColor !== "none") {
		classNameNodes.push(orderColor as string);
	} else if (!isUndefined(item.isOwn) && item?.additionalFields?.transfer) {
		const {
			status,
			isOwn,
			additionalFields,
			executorToOrder,
			taxiService,
			globalId,
		} = item;
		const { transfer } = additionalFields;

		const executor =
			executorToOrder && executorToOrder?.length
				? executorToOrder?.[0]?.executor
				: undefined;

		if (isOwn && executor?.taxiService?.id !== taxiService?.id) {
			if (
				transfer?.sendProcess?.currentTransferStage &&
				!executorToOrder?.length &&
				!transfer?.lastReceivedOrder?.executorToOrder?.length
			) {
				classNameNodes.push(TransferOptionEnum.SENT_TRANSFER); // orange
			}

			if (transfer?.lastReceivedOrder?.executorToOrder?.length) {
				classNameNodes.push(TransferOptionEnum.SENT_TRANSFER); // pink
			}
		}

		if (!isOwn) {
			if (!executorToOrder?.length) {
				if (
					status === "closed" &&
					transfer?.executor !== null &&
					globalId
				) {
					classNameNodes.push(TransferOptionEnum.RECEIVED_TRANSFER); // green
				} else {
					classNameNodes.push(TransferOptionEnum.RECEIVED_TRANSFER); // blue
				}
			}

			if (executorToOrder?.length) {
				classNameNodes.push(TransferOptionEnum.RECEIVED_TRANSFER); // green
			}
		}
	} else {
		classNameNodes.push(item?.source ?? "source");
	}

	return classNameNodes.join("-");
};

const filterOrdersByCloseReason = (
	closeReason: CloseReason,
	data: Order.Model[],
): Order.Model[] =>
	data.filter((item) => {
		const lastReceivedOrder =
			item?.additionalFields?.transfer?.lastReceivedOrder;

		const statusDyn = () => {
			const toValue = item.closedOrderComments?.[0];

			if (toValue?.status === "hide_by_transfer") {
				const fromTransferValue =
					lastReceivedOrder?.closedOrderComments?.[0];
				return fromTransferValue;
			}

			return toValue;
		};

		const isStatus = statusDyn()?.status === closeReason;
		return isStatus;
	});

const isNonEmptyString = (value: unknown): value is string =>
	typeof value === "string" && value.trim() !== "";

const isValidOrderNumber = (str: string): boolean =>
	/^\d+(,\d+)*(\s*,\s*\d+)*$/.test(str);

const parseOrderNumbers = (str: string): number[] => {
	if (!isValidOrderNumber(str)) return [];
	return str.replace(/\s+/g, "").split(",").map(Number);
};

// const applyOrderFilters2 = (
// 	orders: Order.Model[],
// 	valueModal: ArchiveOrderFiltersModal.Value,
// 	t: UseTranslationResponse<"translation", undefined>[0],
// ): Order.Model[] => {
// 	let retval = orders;

// 	// filter fill and company
// 	if (valueModal.taxiServiceIds?.length) {
// 		retval = retval.filter((order) =>
// 			typeof order.taxiService?.id === "number"
// 				? valueModal.taxiServiceIds.includes(order.taxiService.id)
// 				: false,
// 		);
// 	}

// 	// filter executor
// 	if (valueModal.checkBoxExecutorIds) {
// 		if (valueModal.executorIds?.length) {
// 			retval = retval.filter((order) => {
// 				const id = order.executorToOrder?.[0]?.executor?.id;

// 				return typeof id === "number"
// 					? valueModal.executorIds.includes(id)
// 					: false;
// 			});
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter status of order
// 	if (valueModal.checkBoxStatusOrder) {
// 		if (valueModal.statusOrder?.length) {
// 			const statusOrderStringArr = valueModal.statusOrder.map(
// 				(key) => ORDER_STATUSES[key],
// 			);

// 			const arrMiltyFilterSome: Order.Model[][] = [];

// 			if (
// 				statusOrderStringArr.includes(
// 					ORDER_STATUSES_ENUM.UnclosedOrders,
// 				)
// 			) {
// 				const arrBuffer = retval.filter(
// 					(item) =>
// 						item.executingStage !== OrderExecutingStage.EXECUTED &&
// 						item.executingStage !== OrderExecutingStage.FAILED,
// 				);

// 				if (arrBuffer.length) arrMiltyFilterSome.push(arrBuffer);
// 			}
// 			if (
// 				statusOrderStringArr.includes(
// 					ORDER_STATUSES_ENUM.CompletedOrders,
// 				)
// 			) {
// 				const cellProcessingForOnlyExecutor = (
// 					item: Order.Model,
// 				): boolean => {
// 					const lastReceivedOrder =
// 						item?.additionalFields?.transfer?.lastReceivedOrder;

// 					const toValue = item?.closedOrderComments?.[0];
// 					const comment =
// 						toValue?.status === "hide_by_transfer"
// 							? lastReceivedOrder?.closedOrderComments?.[0]
// 							: toValue;

// 					const isExecutor = comment?.status === "executed";

// 					return isExecutor;
// 				};

// 				const arrBuffer = retval.filter(
// 					(item) =>
// 						item.executingStage === OrderExecutingStage.EXECUTED ||
// 						cellProcessingForOnlyExecutor(item),
// 				);

// 				if (arrBuffer.length) arrMiltyFilterSome.push(arrBuffer);
// 			}

// 			if (
// 				statusOrderStringArr.includes(
// 					ORDER_STATUSES_ENUM.NoCarAvailable,
// 				)
// 			) {
// 				const arrBuffer = filterOrdersByCloseReason(
// 					CloseReason.NoCar,
// 					retval,
// 				);

// 				if (arrBuffer.length) arrMiltyFilterSome.push(arrBuffer);
// 			}

// 			if (
// 				statusOrderStringArr.includes(ORDER_STATUSES_ENUM.ClientRefusal)
// 			) {
// 				const arrBuffer = filterOrdersByCloseReason(
// 					CloseReason.ClientCanceled,
// 					retval,
// 				);

// 				if (arrBuffer.length) arrMiltyFilterSome.push(arrBuffer);
// 			}

// 			if (
// 				statusOrderStringArr.includes(ORDER_STATUSES_ENUM.DriverRefusal)
// 			) {
// 				const arrBuffer = filterOrdersByCloseReason(
// 					CloseReason.ExecutorCanceled,
// 					retval,
// 				);

// 				if (arrBuffer.length) arrMiltyFilterSome.push(arrBuffer);
// 			}

// 			if (
// 				statusOrderStringArr.includes(
// 					ORDER_STATUSES_ENUM.CalculationError,
// 				)
// 			) {
// 				const arrBuffer = filterOrdersByCloseReason(
// 					CloseReason.Miscalculate,
// 					retval,
// 				);

// 				if (arrBuffer.length) arrMiltyFilterSome.push(arrBuffer);
// 			}

// 			if (
// 				statusOrderStringArr.includes(
// 					ORDER_STATUSES_ENUM.DispatcherError,
// 				)
// 			) {
// 				const arrBuffer = filterOrdersByCloseReason(
// 					CloseReason.DispatcherMistake,
// 					retval,
// 				);

// 				if (arrBuffer.length) arrMiltyFilterSome.push(arrBuffer);
// 			}

// 			const mergedOrders: Order.Model[] = Array.from(
// 				new Map(
// 					arrMiltyFilterSome.flat().map((order) => [order.id, order]),
// 				).values(),
// 			);

// 			retval = mergedOrders;
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter number by order
// 	if (valueModal.checkNumberOrder) {
// 		// item.orderNumber

// 		if (
// 			isNonEmptyString(valueModal.numberOrder) &&
// 			isValidOrderNumber(valueModal.numberOrder)
// 		) {
// 			const arrFilter = parseOrderNumbers(valueModal.numberOrder);
// 			retval = retval.filter((order) =>
// 				arrFilter.includes(order.orderNumber),
// 			);
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter phone client
// 	if (valueModal.checkNumberPhone) {
// 		if (isNonEmptyString(valueModal.numberPhone)) {
// 			retval = retval.filter((order) => {
// 				const phonesFromOrder = order.phones.map(
// 					(phone) => phone.number ?? "",
// 				);

// 				return phonesFromOrder.some((phone) =>
// 					phone.includes(valueModal.numberPhone),
// 				);
// 			});
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter street address
// 	if (valueModal.checkStreet) {
// 		if (isNonEmptyString(valueModal.street)) {
// 			retval = retval.filter((order) => {
// 				const points = getOrderPassengerPoints(order) || [];

// 				return points.some((point) =>
// 					isTextMatchingAnySegmentFilterHelper(
// 						stringifyPoint(
// 							point,
// 							"address",
// 							t(["point_on_map"]) ?? "point_on_map",
// 						),
// 						valueModal.street,
// 					),
// 				);
// 			});
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter client
// 	if (valueModal.checkClient) {
// 		if (valueModal.client?.length) {
// 			retval = retval.filter((order) => {
// 				const arrPasagers: number[] =
// 					order.passengers?.map(
// 						(passanger) => passanger?.customer?.id ?? -1,
// 					) || [];

// 				return arrPasagers.some((passanger) =>
// 					valueModal.client.includes(passanger),
// 				);
// 			});
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter counterparty
// 	if (valueModal.checkCounterparty) {
// 		if (valueModal.counterparty?.length) {
// 			retval = retval.filter((order) => {
// 				const isId = order.counterparty?.id;
// 				if (!isId) return false;

// 				return valueModal.counterparty.includes(isId);
// 			});
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter agent
// 	if (valueModal.checkAgent) {
// 		if (valueModal.agent?.length) {
// 			retval = retval.filter((order) => {
// 				const isId = order.agent?.id;
// 				if (!isId) return false;

// 				return valueModal.agent.includes(isId);
// 			});
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter payments
// 	if (valueModal.checkPayments) {
// 		if (valueModal.payments?.length) {
// 			const paymentsStringArr = valueModal.payments.map(
// 				(key) => PAYMENTS[key],
// 			);

// 			const arrMiltyFilterSome: Order.Model[][] = [];

// 			if (paymentsStringArr.includes(PAYMENTS_ENUM.Cash)) {
// 				const arrBuffer = retval.filter(
// 					(item) => item.paymentType === Order.PaymentType.Cash,
// 				);

// 				if (arrBuffer.length) arrMiltyFilterSome.push(arrBuffer);
// 			}

// 			if (paymentsStringArr.includes(PAYMENTS_ENUM.Card)) {
// 				const arrBuffer = retval.filter(
// 					(item) => item.paymentType === Order.PaymentType.Card,
// 				);

// 				if (arrBuffer.length) arrMiltyFilterSome.push(arrBuffer);
// 			}

// 			if (paymentsStringArr.includes(PAYMENTS_ENUM.Corporate)) {
// 				const arrBuffer = retval.filter(
// 					(item) =>
// 						item.paymentType === Order.PaymentType.Invoice ||
// 						item.paymentType === Order.PaymentType.CompanyBill,
// 				);

// 				if (arrBuffer.length) arrMiltyFilterSome.push(arrBuffer);
// 			}

// 			const mergedOrders: Order.Model[] = Array.from(
// 				new Map(
// 					arrMiltyFilterSome.flat().map((order) => [order.id, order]),
// 				).values(),
// 			);

// 			retval = mergedOrders;
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter classes
// 	if (valueModal.checkClasses) {
// 		if (valueModal.classes?.length) {
// 			retval = retval.filter((order) => {
// 				const carClassessFromOrder: number[] =
// 					order.orderToCarClasses?.map(
// 						(item) => item?.carClass?.id || -1,
// 					) || [];
// 				return carClassessFromOrder.some((num) =>
// 					valueModal.classes.includes(num),
// 				);
// 			});
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter services
// 	if (valueModal.checkServices) {
// 		if (valueModal.services?.length) {
// 			retval = retval.filter((order) => {
// 				const servicesFromOrder =
// 					order.orderToServices?.map(
// 						(item) => item?.service?.id || -1,
// 					) || [];

// 				return servicesFromOrder.some((num) =>
// 					valueModal.services.includes(num),
// 				);
// 			});
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter sectors
// 	if (valueModal.checkSectors) {
// 		if (valueModal.sectors?.length) {
// 			retval = retval.filter((order) => {
// 				const points = getOrderPassengerPoints(order) || [];
// 				const pointsIds: number[] = points.map(
// 					(point) => point?.sector?.id ?? -1,
// 				);

// 				return pointsIds.some((id) => valueModal.sectors.includes(id));
// 			});
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter transfer
// 	if (valueModal.checkTransfer) {
// 		if (valueModal.transfer?.length) {
// 			retval = retval.filter((order) => {
// 				const checkOutOrderToTransfer2 = tableRowClassName2(order);

// 				const isnNeedFilterToValueSelect = valueModal.transfer.some(
// 					(string) => string === checkOutOrderToTransfer2,
// 				);

// 				return isnNeedFilterToValueSelect;
// 			});
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	// filter sourceCallSing
// 	if (valueModal.checkSourceCallSing) {
// 		if (valueModal.sourceCallSing?.length) {
// 			retval = retval.filter((order) => {
// 				const callSignUser =
// 					order?.additionalFields?.initiator?.callSign ?? -2;

// 				const isDispatcher = order.source === OrderSource.DISPATCHER;
// 				const isPhone = order.source === OrderSource.PHONE;
// 				const isCallSignNeed = valueModal.sourceCallSing.some(
// 					(callSig) => callSig === (Number(callSignUser) || -2),
// 				);

// 				return (isDispatcher || isPhone) && isCallSignNeed;
// 			});
// 		} else {
// 			retval = [];
// 		}
// 	}

// 	return retval;
// };

const applyOrderFilters = (
	orders: Order.Model[],
	valueModal: ValueDefaultFilters,
	t: UseTranslationResponse<"translation", undefined>[0],
	filterDateRange?: DateRange,
): Order.Model[] =>
	orders.filter((order) => {
		// 🗓 filter by date range
		if (filterDateRange) {
			const orderDate = new Date(order.createdAt);
			if (Number.isNaN(orderDate.getTime())) return false;

			if (
				orderDate < filterDateRange.from ||
				orderDate > filterDateRange.to
			) {
				return false;
			}
		}

		// 🚕 filter taxiService
		if (valueModal.taxiServiceIds?.length) {
			if (
				typeof order.taxiService?.id !== "number" ||
				!valueModal.taxiServiceIds.includes(order.taxiService.id)
			) {
				return false;
			}
		}

		// 👷 filter executor
		if (valueModal.checkBoxExecutorIds) {
			if (valueModal.executorIds?.length) {
				const id = order.executorToOrder?.[0]?.executor?.id;
				if (
					typeof id !== "number" ||
					!valueModal.executorIds.includes(id)
				) {
					return false;
				}
			} else {
				return false;
			}
		}

		// 📦 filter status
		if (valueModal.checkBoxStatusOrder) {
			if (valueModal.statusOrder?.length) {
				const statusOrderStringArr = valueModal.statusOrder.map(
					(key) => ORDER_STATUSES[key],
				);

				let matched = false;

				if (
					statusOrderStringArr.includes(
						ORDER_STATUSES_ENUM.UnclosedOrders,
					)
				) {
					if (
						order.executingStage !== OrderExecutingStage.EXECUTED &&
						order.executingStage !== OrderExecutingStage.FAILED
					) {
						matched = true;
					}
				}

				if (
					statusOrderStringArr.includes(
						ORDER_STATUSES_ENUM.CompletedOrders,
					)
				) {
					const lastReceivedOrder =
						order?.additionalFields?.transfer?.lastReceivedOrder;
					const toValue = order?.closedOrderComments?.[0];
					const comment =
						toValue?.status === "hide_by_transfer"
							? lastReceivedOrder?.closedOrderComments?.[0]
							: toValue;

					if (
						order.executingStage === OrderExecutingStage.EXECUTED ||
						comment?.status === "executed"
					) {
						matched = true;
					}
				}

				if (
					statusOrderStringArr.includes(
						ORDER_STATUSES_ENUM.NoCarAvailable,
					)
				) {
					if (
						filterOrdersByCloseReason(CloseReason.NoCar, [order])
							.length
					) {
						matched = true;
					}
				}

				if (
					statusOrderStringArr.includes(
						ORDER_STATUSES_ENUM.ClientRefusal,
					)
				) {
					if (
						filterOrdersByCloseReason(CloseReason.ClientCanceled, [
							order,
						]).length
					) {
						matched = true;
					}
				}

				if (
					statusOrderStringArr.includes(
						ORDER_STATUSES_ENUM.DriverRefusal,
					)
				) {
					if (
						filterOrdersByCloseReason(
							CloseReason.ExecutorCanceled,
							[order],
						).length
					) {
						matched = true;
					}
				}

				if (
					statusOrderStringArr.includes(
						ORDER_STATUSES_ENUM.CalculationError,
					)
				) {
					if (
						filterOrdersByCloseReason(CloseReason.Miscalculate, [
							order,
						]).length
					) {
						matched = true;
					}
				}

				if (
					statusOrderStringArr.includes(
						ORDER_STATUSES_ENUM.DispatcherError,
					)
				) {
					if (
						filterOrdersByCloseReason(
							CloseReason.DispatcherMistake,
							[order],
						).length
					) {
						matched = true;
					}
				}

				if (!matched) return false;
			} else {
				return false;
			}
		}

		// 🔢 filter order number
		if (valueModal.checkNumberOrder) {
			if (
				!isNonEmptyString(valueModal.numberOrder) ||
				!isValidOrderNumber(valueModal.numberOrder)
			) {
				return false;
			}
			const arrFilter = parseOrderNumbers(valueModal.numberOrder);
			if (!arrFilter.includes(order.orderNumber)) return false;
		}

		// 📞 filter phone
		if (valueModal.checkNumberPhone) {
			if (!isNonEmptyString(valueModal.numberPhone)) return false;
			const phones = order.phones.map((p) => p.number ?? "");
			if (!phones.some((p) => p.includes(valueModal.numberPhone))) {
				return false;
			}
		}

		// 🏠 filter street
		if (valueModal.checkStreet) {
			if (!isNonEmptyString(valueModal.street)) return false;
			const points = getOrderPassengerPoints(order) || [];
			if (
				!points.some((point) =>
					isTextMatchingAnySegmentFilterHelper(
						stringifyPoint(
							point,
							"address",
							t(["point_on_map"]) ?? "point_on_map",
						),
						valueModal.street,
					),
				)
			) {
				return false;
			}
		}

		// 👤 filter client
		if (valueModal.checkClient) {
			if (!valueModal.client?.length) return false;
			const passengerIds =
				order.passengers?.map((p) => p?.customer?.id ?? -1) ?? [];
			if (!passengerIds.some((id) => valueModal.client.includes(id))) {
				return false;
			}
		}

		// 🏢 filter counterparty
		if (valueModal.checkCounterparty) {
			if (!valueModal.counterparty?.length) return false;
			if (
				!order.counterparty?.id ||
				!valueModal.counterparty.includes(order.counterparty.id)
			) {
				return false;
			}
		}

		// 🤝 filter agent
		if (valueModal.checkAgent) {
			if (!valueModal.agent?.length) return false;
			if (
				!order.agent?.id ||
				!valueModal.agent.includes(order.agent.id)
			) {
				return false;
			}
		}

		// 💳 filter payments
		if (valueModal.checkPayments) {
			if (!valueModal.payments?.length) return false;
			const paymentsStringArr = valueModal.payments.map(
				(key) => PAYMENTS[key],
			);

			let matched = false;
			if (
				paymentsStringArr.includes(PAYMENTS_ENUM.Cash) &&
				order.paymentType === Order.PaymentType.Cash
			) {
				matched = true;
			}
			if (
				paymentsStringArr.includes(PAYMENTS_ENUM.Card) &&
				order.paymentType === Order.PaymentType.Card
			) {
				matched = true;
			}
			if (
				paymentsStringArr.includes(PAYMENTS_ENUM.Company_bill) &&
				(order.paymentType === Order.PaymentType.Invoice ||
					order.paymentType === Order.PaymentType.CompanyBill)
			) {
				matched = true;
			}

			if (!matched) return false;
		}

		// 🚘 filter classes
		if (valueModal.checkClasses) {
			if (!valueModal.classes?.length) return false;
			const carClasses =
				order.orderToCarClasses?.map((c) => c?.carClass?.id || -1) ??
				[];
			if (!carClasses.some((id) => valueModal.classes.includes(id))) {
				return false;
			}
		}

		// 🛠 filter services
		if (valueModal.checkServices) {
			if (!valueModal.services?.length) return false;
			const services =
				order.orderToServices?.map((s) => s?.service?.id || -1) ?? [];
			if (!services.some((id) => valueModal.services.includes(id))) {
				return false;
			}
		}

		// 📍 filter sectors
		if (valueModal.checkSectors) {
			if (!valueModal.sectors?.length) return false;
			const points = getOrderPassengerPoints(order) || [];
			const pointIds = points.map((p) => p?.sector?.id ?? -1);
			if (!pointIds.some((id) => valueModal.sectors.includes(id))) {
				return false;
			}
		}

		// 🔄 filter transfer
		if (valueModal.checkTransfer) {
			if (!valueModal.transfer?.length) return false;
			const transferClass = tableRowClassName2(order);
			if (!valueModal.transfer.some((tr) => tr === transferClass)) {
				return false;
			}
		}

		// 📞 filter sourceCallSing
		if (valueModal.checkSourceCallSing) {
			if (!valueModal.sourceCallSing?.length) return false;
			const callSignUser =
				order?.additionalFields?.initiator?.callSign ?? -2;
			const isDispatcher = order.source === OrderSource.DISPATCHER;
			const isPhone = order.source === OrderSource.PHONE;
			if (
				!(isDispatcher || isPhone) ||
				!valueModal.sourceCallSing.some(
					(c) => c === (Number(callSignUser) || -2),
				)
			) {
				return false;
			}
		}

		return true;
	});

export default applyOrderFilters;
